import { createSlice } from "@reduxjs/toolkit";
import {
  ContactRenewalList,
  ContactRenewalRetrieve,
  ContactRenewalTypeList,
} from "Shared/Types/fleetmanagementapi";
import {
  createReminderContact,
  deleteReminderContact,
  getReminderConcactTypes,
  getReminderContactById,
  getReminderContactList,
  updateReminderContact,
} from "./reducer";
import { RootState } from "Redux/store";

type State = {
  loading: boolean;
  reminderContactList: ContactRenewalList[];
  currentContactReminder: ContactRenewalRetrieve | null;
  count: number;
  types: ContactRenewalTypeList[];
  isFuncLoading: boolean;
};

const initialState: State = {
  loading: false,
  isFuncLoading: false,
  reminderContactList: [],
  currentContactReminder: null,
  count: 0,
  types: [],
};

const reminderContactSlice = createSlice({
  name: "reminder",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getReminderContactList.fulfilled, (state, action) => {
      state.loading = false;
      state.reminderContactList = action.payload.results;
      state.count = action.payload.count;
    });
    builder.addCase(getReminderContactList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getReminderContactList.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getReminderContactById.fulfilled, (state, action) => {
      state.loading = false;
      state.currentContactReminder = action.payload;
    });
    builder.addCase(getReminderConcactTypes.fulfilled, (state, action) => {
      state.types = action.payload.results;
    });

    builder.addCase(createReminderContact.pending, (state) => {
      state.isFuncLoading = true;
    });
    builder.addCase(createReminderContact.fulfilled, (state) => {
      state.isFuncLoading = false;
    });
    builder.addCase(createReminderContact.rejected, (state, action) => {
      state.isFuncLoading = false;
    });

    builder.addCase(updateReminderContact.pending, (state) => {
      state.isFuncLoading = true;
    });
    builder.addCase(updateReminderContact.fulfilled, (state) => {
      state.isFuncLoading = false;
    });
    builder.addCase(updateReminderContact.rejected, (state, action) => {
      state.isFuncLoading = false;
    });

    builder.addCase(deleteReminderContact.pending, (state) => {
      state.isFuncLoading = true;
    });
    builder.addCase(deleteReminderContact.fulfilled, (state) => {
      state.isFuncLoading = false;
    });
    builder.addCase(deleteReminderContact.rejected, (state, action) => {
      state.isFuncLoading = false;
    });
  },
});

export const selectReminderContactList = (state: RootState) =>
  state.reminderContact.reminderContactList;
export const selectCurrentReminderContact = (state: RootState) =>
  state.reminderContact.currentContactReminder;
export const selectReminderContactLoading = (state: RootState) =>
  state.reminderContact.loading;
export const selectReminderContactIsFuncLoading = (state: RootState) =>
  state.reminderContact.isFuncLoading;
export const selectReminderContactCount = (state: RootState) =>
  state.reminderContact.count;
export const selectReminderContactTypes = (state: RootState) =>
  state.reminderContact.types;

export default reminderContactSlice;
